import { cloneDeep } from 'lodash';
import React, { useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { TcsmModal } from '../../../../../global/components/tcsm-modal';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';
import { useStateWithDependency } from '../../../../../global/hooks/useStateWIthDependency';
import { QuickActionGroup, QuickActionItem } from '../../../../../global/models/quick-actions-model';
import { MapPortalProps } from '../../../models/arc-epi-props';
import { ButtonWrapper } from '../../../../../global/components/layout/button-wrapper';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { QuickActionsGroupDisplay } from './quick-actions-group-display';

interface Props {
    open: boolean;
    portalProps: MapPortalProps;
    setModalOpen: (value: React.SetStateAction<boolean>) => void;
    selectedQuickActions: QuickActionItem[];
    quickActionGroups: QuickActionGroup[];
    allQuickActions: QuickActionItem[];
    setQuickActions: (items: QuickActionItem[]) => void;
}
export function QuickActionsAddRemove(props: Props) {
    const { open, portalProps, setModalOpen, selectedQuickActions, quickActionGroups, allQuickActions, setQuickActions } = props;

    

    const initialAccordionMap = {};
    for (let i = 0; i < quickActionGroups?.length; i += 1) {
        initialAccordionMap[quickActionGroups[i].groupName] = true;
    }

    const [accordionMap, setAccordionMap] = useState(initialAccordionMap);
    const [tempActions, setTempActions] = useStateWithDependency(selectedQuickActions);

    const allCollapsed = Object.keys(accordionMap)?.every(key => !accordionMap[key]);
    const buttonClasses = allCollapsed ? 'quick-action-edit-trigger' : 'quick-action-edit-trigger quick-action-edit-trigger-open';
    const onResetState = () => {
        setTempActions(selectedQuickActions);
        setAccordionMap(initialAccordionMap);
    };

    const onClose = () => {
        onResetState();
        setModalOpen(false);
    };

    const expandAll = () => {
        setAccordionMap(initialAccordionMap);
    };

    const collapseAll = () => {
        const accordionCopy = cloneDeep(accordionMap);
        const keys = Object.keys(accordionCopy);
        for (let i = 0; i < keys?.length; i += 1) {
            const key = keys[i];
            accordionCopy[key] = false;
        }

        setAccordionMap(accordionCopy);
    };

    const toggleGroupExpanded = (key: string) => {
        const updatedState = {
            ...accordionMap,
            [key]: !accordionMap[key],
        };
        setAccordionMap(updatedState);
    };

    const onToggleAllExpanded = () => {
        if (allCollapsed) {
            expandAll();
        } else {
            collapseAll();
        }
    };

    const addQuickAction = (id: string) => {
        const match = allQuickActions?.find(x => x.id === id);
        if (match) {
            setTempActions([
                ...tempActions,
                match,
            ]);
        }
    };

    const removeQuickAction = (id: string) => {
        setTempActions((prevState: QuickActionItem[]) => prevState?.filter(x => x.id !== id));
    };

    const onDone = () => {
        setQuickActions(tempActions);
        setAccordionMap(initialAccordionMap);
        setModalOpen(false);
    };

    return (
        <TcsmModal largeModal open={open} handleClose={onClose}>
            <ContentSpacer>
                <div>
                    <h2 className='quick-action-edit-title'>{portalProps?.addOrRemoveActionsModalHeader}</h2>
                    <WysiwygWithReactLink content={portalProps?.addOrRemoveInstructions} />
                </div>
            </ContentSpacer>
            <div className='quick-action-edit-header'>
                <h3>{portalProps?.availableActionsHeader}</h3>

                <button
                    type='button'
                    onClick={onToggleAllExpanded}
                    className={buttonClasses}>
                    {allCollapsed ? portalProps?.expandAllText || 'Expand All' : portalProps?.collapseAllText || 'Collapse All'}
                    <ExpandMoreIcon />
                </button>
            </div>
            {quickActionGroups?.map(group => {
                return (
                    <QuickActionsGroupDisplay
                        key={group.groupName}
                        portalProps={portalProps}
                        group={group}
                        selectedQuickActions={tempActions}
                        expanded={accordionMap[group?.groupName]}
                        toggleGroupExpanded={toggleGroupExpanded}
                        addQuickAction={addQuickAction}
                        removeQuickAction={removeQuickAction}
                    />
                );
            })}
            <ButtonWrapper flexEnd>
                <button className='btn-tertiary' type='button' onClick={onClose}>{portalProps?.cancelText}</button>
                <button className='btn' type='button' onClick={onDone}>{portalProps?.doneText}</button>
            </ButtonWrapper>
        </TcsmModal>
    );
}